import {Data} from './data';
import { Facture } from './facture';
import { Compte } from './compte';
import { Partenaire } from './partenaire';
import { CashSession } from './cashsession';


export class Flux extends Data {

    libelle: string;
    date_flux: string;
    type_flux: string;
    nature_flux: string;
    commentaire: string;
    montant: number;
    valider: boolean;
    cloturer: boolean;
    facture: Facture;
    solde: number;
    compte: Compte;
    op_compte: Compte;
    partenaire: Partenaire;
    cashsession: CashSession;
    cash_session_name: string;
    cash_session_id: number;
    cash_session_account: string;
    type_session: string;
    label_nature: string;
    type_partenaire: string;
    id_facture: number;
    close_cashstate: boolean;
    vente_direct: boolean;


    constructor() {
        super(); // on appelle le constructeur du parent;
        this.montant = 0;
    }


    get formatDateFlux(): string {
        if (this.date_flux !== null)
        return  this.formatDate(this.date_flux);
        else
        return '';
    }

    get designationCompte(): string {
        if (this.compte !== null && this.compte !== undefined)
        return  this.compte.designation;
        else
        return '';
    }


    /* get labelPartenaire(): string {

        if (this.nature_flux === 'reglement') {


            if (this.facture.type_facture === 'vente') {

               // return 'Facture Client ' + this.facture.refgene;
               if (this.facture.partenaire !== null)
               return this.facture.partenaire.nom ;
               else
               return 'Client ';

            } else {

               if (this.facture.partenaire !== null)
               return  this.facture.partenaire.nom;
               else
               return 'fournisseur';

            }


        } else {

            if (this.partenaire !== null && this.partenaire !== undefined) {

                if (this.nature_flux === 'caisse') {

                    if (this.type_flux === 'entree')
                    return  this.partenaire.nom;

                    if (this.type_flux === 'sortie')
                    return  this.partenaire.nom;

                } else {

                    return '';
                }

            } else
            return '';

        }

    }

    get labelNature(): string {

        let label = '';

        if (this.libelle !== null && this.libelle !== undefined)
        label = this.libelle;

        if (this.nature_flux === 'reglement') {

            return label + ' '  + 'Règlement ' + ' ' + this.labelPartenaire + ' - Facture ' + this.facture.refgene + ' DU ' + this.formatDate(this.facture.date_facturation);

        } else {

            if (this.op_compte !== null && this.op_compte !== undefined)
            return  label + ' ' + this.op_compte.designation + ' ' + this.labelPartenaire;
            else
            return  label + ' ' + this.labelPartenaire;

        }
    } */


    get entree(): number {
        if (this.type_flux !== 'sortie')
        return  this.montant;
        else
        return null;
    }

    get sortie(): number {
        if (this.type_flux !== 'entree')
        return  this.montant;
        else
        return null;
    }

    get sessionId(): number {
        if (this.cashsession !== null && this.cashsession !== undefined)
        return this.cashsession.id;
        else
        return null;
    }

    /* get label(): string {

        if (this.nature_flux === 'reglement') {


            if (this.facture.type_facture === 'vente') {

               // return 'Facture Client ' + this.facture.refgene;
               if (this.facture.partenaire !== null)
               return 'Règlement Facture Client ' + this.facture.partenaire.nom;
               else
               return 'Règlement Facture Client ';

            } else {

               if (this.facture.partenaire !== null)
               return 'Règlement Facture Fournisseur ' + this.facture.partenaire.nom;
               else
               return 'Règlement Facture Fournisseur';

            }


        } else {

            if (this.compte !== null && this.compte !== undefined) {

                return this.compte.designation;

            } else {

                return this.libelle;

            }

        }

        // return 'Versement facture client';

    } */

}
